import { Eye, NotePencil, Trash } from "@phosphor-icons/react";

export default function TabelaRow({ chamado, onDetalhe, onEditar, onExcluir }) {
  const getStatusClasses = (status) => {
    switch (status) {
      case "Finalizado":
        return "bg-green-100 text-green-700";
      case "Pendente":
        return "bg-red-100 text-red-700";
      case "Aberto":
        return "bg-yellow-100 text-yellow-700";
      case "Atendendo":
        return "bg-blue-100 text-blue-700";
      default:
        return "bg-gray-100 text-gray-700";
    }
  };

  // Função para formatar data YYYY-MM-DD -> DD-MM-YYYY
  const formatarData = (data) => {
    if (!data || data === "0000-00-00") return "—";
    const [ano, mes, dia] = data.split("-");
    return `${dia}-${mes}-${ano}`;
  };

  return (
    <tr
      className="
        hover:bg-slate-50 transition-colors
        odd:bg-white even:bg-slate-100
      "
    >
      {/* Data */}
      <td className="px-2 py-2 text-sm border border-slate-300 text-center">
        {formatarData(chamado.data_abertura)}
      </td>

      {/* Hora */}
      <td className="px-2 py-2 text-sm border border-slate-300 text-center">
        {chamado.hora_abertura}
      </td>

      {/* Finalizado (mostrando finalizado_em formatado - sem negrito) */}
      <td className="px-2 py-2 text-sm border border-slate-300 text-center">
        {formatarData(chamado.finalizado_em)}
      </td>

      {/* Empresa */}
      <td className="px-2 py-2 text-sm border border-slate-300 text-center font-bold">
        {chamado.empresa}
      </td>

      {/* Colaborador */}
      <td className="px-2 py-2 text-sm border border-slate-300 text-center">
        {chamado.colaborador}
      </td>

      {/* Tipo de Serviço */}
      <td className="px-2 py-2 text-sm border border-slate-300 text-center">
        {chamado.tipo_servico}
      </td>

      {/* Técnico */}
      <td className="px-2 py-2 text-sm border border-slate-300 text-center">
        {chamado.tecnico_responsavel}
      </td>

      {/* Status */}
      <td className="px-2 py-2 text-sm border border-slate-300 text-center">
        <span
          className={`px-2 py-1 text-xs rounded font-medium ${getStatusClasses(
            chamado.status
          )}`}
        >
          {chamado.status}
        </span>
      </td>

      {/* Ações */}
      <td className="px-2 py-2 flex items-center justify-center gap-2 border border-slate-300">
        {/* 🔹 Visualizar */}
        <button
          onClick={() => onDetalhe?.(chamado)}
          className="hover:scale-110 transition-transform p-1"
          title="Visualizar"
        >
          <Eye size={18} color="#606060" weight="duotone" />
        </button>

        {/* 🔹 Editar */}
        <button
          onClick={() => onEditar?.(chamado)}
          className="hover:scale-110 transition-transform p-1"
          title="Editar"
        >
          <NotePencil size={18} color="#606060" weight="duotone" />
        </button>

        {/* 🔹 Excluir */}
        <button
          onClick={() => onExcluir?.(chamado)}
          className="hover:scale-110 transition-transform p-1"
          title="Excluir"
        >
          <Trash size={18} color="#606060" weight="duotone" />
        </button>
      </td>
    </tr>
  );
}
